import { Outlet } from 'react-router-dom';
import { Contacts } from '@widgets';
import { Logo } from '@shared/widgets';
import bgImg from '@assets/images/login-bg.jpg';

export const RecoveryPage = () => {
  return (
    <div className='bg-cover bg-center bg-no-repeat' style={{ backgroundImage: `url(${bgImg})` }}>
      <div className='relative mx-auto flex min-h-screen w-full max-w-[330px] flex-col justify-center py-10 text-[#929292]'>
        <div className='mx-auto mb-13'>
          <Logo width='210' height='28' />
        </div>
        <Outlet />
        <div className='mt-7.5 text-center text-xs font-medium text-[#626262] uppercase'>
          <div>
            If you can’t remember your ICA password, please use the password retrieval process by filling in the form on the right. A message will be
            sent to your personal email address registered with your account with the login details.
            <br />
            <br />
            We strongly recommend that you change your password regularly for security enhancement.
          </div>
        </div>
        <Contacts className='animat-up-long' />
      </div>
    </div>
  );
};
